import axios from '@/libs/api.request'
var qs = require('qs')

// 获取列表数据
export const fetchTableList = (params) => {

    let data = qs.stringify(params);
    return axios.request({
        url: '/classes/classes-list',
        data,
        method: 'post'
    })
};
// 获取校区下拉
export const fetchSchoolList = (params) => {
    let data = params;
    data = qs.stringify(data);
    return axios.request({
        url: 'student/school-list',
        data,
        method: 'post'
    })
};
// 获取老师列表
export const fetchTeacherList = (params) => {
    let data = qs.stringify(params);
    return axios.request({
        url: '/classes/teacher-list',
        data,
        method: 'post'
    })
};
// 分配老师
export const fetchAssignTeacher = (params) => {
    let data = qs.stringify(params);
    return axios.request({
        url: '/classes/allot-teacher',
        data,
        method: 'post'
    })
};
// 分配课程
export const fetchAssignClass = (params) => {
    let data = qs.stringify(params);
    return axios.request({
        url: '/classes/add-lesson',
        data,
        method: 'post'
    })
};
// 获取课程列表
export const fetchClass = (params) => {
    let data = qs.stringify(params);
    return axios.request({
        url: '/classes/class-lesson',
        data,
        method: 'post'
    })
};
// 获取课程下拉
export const fetchClassList = (params) => {
    let data = qs.stringify(params);
    return axios.request({
        url: '/lesson/class-lesson-list',
        data,
        method: 'post'
    })
};
// 获取章节
export const fetchChapterList = (params) => {
    let data = qs.stringify(params);
    return axios.request({
        url: '/lock/list',
        data,
        method: 'post'
    })
};
// 改变章节状态
export const setState = (params) => {
    let data = qs.stringify(params);
    return axios.request({
        url: '/lock/change-lock',
        data,
        method: 'post'
    })
};
// 添加修改
export const addModify = (params) => {
    let data = qs.stringify(params);

    return axios.request({
        url: '/classes/add-class',
        data,
        method: 'post'
    })
};

// 删除课程
export const setDelete = (params) => {
    let data = qs.stringify(params);

    return axios.request({
        url: '/classes/delete-lesson',
        data,
        method: 'post'
    })
};
// 获取详情
export const fetchInfo = (params) => {
    let data = params
    data = qs.stringify(data)
    return axios.request({
        url: '/classes/info',
        data,
        method: 'post'
    })
};
// 删除班级
export const setDel = (params) => {
    let data = params
    data = qs.stringify(data)
    return axios.request({
        url: '/classes/class-delete',
        data,
        method: 'post'
    })
};